var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inputLabel)?_c('label',{class:_vm.labelClass,attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.inputLabel)),_vm._t("default"),(_vm.isRequired)?_c('span',[_vm._v(" *")]):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }